import React from 'react';

const LoadingPage = () => {
    return (
        <>
            <div>
                    <span>We, questa è una pagina inutile!<br/>
                    Se sei qua vuol dire che ti piace la pagina di loading!</span>
            </div>
        </>
    );
};

export default LoadingPage;